"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAutomaticEmailToStatusDate = transformAutomaticEmailToStatusDate;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformAutomaticEmailToStatusDate(automaticEmail) {
    switch (automaticEmail.status) {
        case legacy_enums_1.AutomaticEmailStatus.Scheduled: // Shedulled to be requested/sent later
            return automaticEmail.scheduledUntil;
        case legacy_enums_1.AutomaticEmailStatus.Requested: // Request sent to mailgun
            return automaticEmail.sentAt;
        case legacy_enums_1.AutomaticEmailStatus.Accepted: // Mailgun accepted the request to send/forward the email and the message has been placed in queue.
            return automaticEmail.acceptedAt;
        case legacy_enums_1.AutomaticEmailStatus.Rejected: // Mailgun rejected the request to send/forward the email.
            return automaticEmail.rejectedAt;
        case legacy_enums_1.AutomaticEmailStatus.Delivered: // Mailgun sent the email and it was accepted by the recipient email server.
            return automaticEmail.deliveredAt;
        case legacy_enums_1.AutomaticEmailStatus.Failed: // Mailgun could not deliver the email to the recipient email server.
            return automaticEmail.failedAt;
        // The email recipient opened the email and enabled image viewing. Open tracking must be enabled in the Mailgun control panel, and the CNAME record must be pointing to mailgun.org.
        case legacy_enums_1.AutomaticEmailStatus.Opened:
            return automaticEmail.openedAt;
        // The email recipient clicked on a link in the email. Click tracking must be enabled in the Mailgun control panel, and the CNAME record must be pointing to mailgun.org.
        case legacy_enums_1.AutomaticEmailStatus.Clicked:
            return automaticEmail.clickedAt;
        case legacy_enums_1.AutomaticEmailStatus.Unsubscribed: // The email recipient clicked on the unsubscribe link. Unsubscribe tracking must be enabled in the Mailgun control panel.
            return automaticEmail.unsubscribedAt;
        // The email recipient clicked on the spam complaint button within their email client. Feedback loops enable the notification to be received by Mailgun.
        case legacy_enums_1.AutomaticEmailStatus.Complained:
            return automaticEmail.complainedAt;
        case legacy_enums_1.AutomaticEmailStatus.Stored: // Mailgun has stored an incoming message
            return automaticEmail.storedAt;
        case legacy_enums_1.AutomaticEmailStatus.Mixed:
            return automaticEmail.sentAt;
        default:
            return undefined;
    }
}
//# sourceMappingURL=transformAutomaticEmailToStatusDate.js.map